import DefaultErrorPage from './errorPages/default';
import CheckoutErrorPage from './errorPages/checkout';
import IncompatibleAdditionalFiber from './errorPages/incompatibleAdditionalFiber';
import AlreadyPurchaseAdditionalFiber from './errorPages/alreadyPurchaseAdditionalFiber';
import AlreadyPurchaseBaf from './errorPages/alreadyPurchaseBaf';
import WrongZoneMiMovistarNoCliente from './errorPages/wrongZoneMiMovistarNoCliente';
import IncompatibleLma from './errorPages/incompatibleLma';
import IncompatibleLmcBundle from './errorPages/incompatibleLmcBundle';
import AlreadyPurchasePromoTv from './errorPages/alreadyPurchasePromoTv';
import AlreadyPurchaseTv from './errorPages/alreadyPurchaseTv';
import DefaultTv from './errorPages/defaultTv';
import PromoExpiredTv from './errorPages/promoExpiredTv';
import AlreadyPurchasePromoFa from './errorPages/alreadyPurchasePromoFa';
import PromoExpiredFa from './errorPages/promoExpiredFa';
import EmptyContactMedia from './errorPages/emptyContactMedia';
import AlreadyClient from './errorPages/alreadyClient';
import IncompatiblePromotionPage from './errorPages/incompatiblePromotionPage';
import { ERROR_PAGES } from './utils';

const ERROR_TO_PRINT = {
  [ERROR_PAGES.DEFAULT]: (props) => <DefaultErrorPage {...props} />,
  [ERROR_PAGES.CHECKOUT]: (props) => <CheckoutErrorPage {...props} />,
  [ERROR_PAGES.INCOMPATIBLE_ADDITIONAL_FIBER_ERROR_PAGE]: (props) => (
    <IncompatibleAdditionalFiber
      {...props}
      componentContent="incompatible-error"
    />
  ),
  [ERROR_PAGES.ALREADY_PURCHASE_ADDITIONAL_FIBER_ERROR_PAGE]: (props) => (
    <AlreadyPurchaseAdditionalFiber
      {...props}
      componentContent="already-purchase-error"
    />
  ),
  [ERROR_PAGES.ALREADY_PURCHASE_BAF_ERROR_PAGE]: (props) => (
    <AlreadyPurchaseBaf {...props} componentContent="already-purchase-error" />
  ),
  [ERROR_PAGES.EMPTY_CONTACT_MEDIA_ERROR_PAGE]: (props) => (
    <EmptyContactMedia
      {...props}
      componentContent="empty-contact-media-error"
    />
  ),
  [ERROR_PAGES.WRONG_ZONE_MIMOVISTAR_NO_CLIENTE]: (props) => (
    <WrongZoneMiMovistarNoCliente
      {...props}
      componentContent="wrong-zone-mimovistar-no-client-error"
    />
  ),
  [ERROR_PAGES.INCOMPATIBLE_LMA_ERROR_PAGE]: (props) => (
    <IncompatibleLma {...props} />
  ),
  [ERROR_PAGES.INCOMPATIBLE_LMC_BUNDLE_ERROR_PAGE]: (props) => (
    <IncompatibleLmcBundle {...props} />
  ),
  [ERROR_PAGES.ALREADY_PURCHASE_PROMO_TV_ERROR_PAGE]: (props) => (
    <AlreadyPurchasePromoTv {...props} />
  ),
  [ERROR_PAGES.ALREADY_PURCHASE_PROMO_FA_ERROR_PAGE]: (props) => (
    <AlreadyPurchasePromoFa {...props} />
  ),
  [ERROR_PAGES.ALREADY_PURCHASE_TV_ERROR_PAGE]: (props) => (
    <AlreadyPurchaseTv {...props} />
  ),
  [ERROR_PAGES.PROMO_EXPIRED_TV_ERROR_PAGE]: (props) => (
    <PromoExpiredTv {...props} />
  ),
  [ERROR_PAGES.PROMO_EXPIRED_FA_ERROR_PAGE]: (props) => (
    <PromoExpiredFa {...props} />
  ),
  [ERROR_PAGES.DEFAULT_TV]: (props) => <DefaultTv {...props} />,
  [ERROR_PAGES.ALREADY_CLIENT]: (props) => <AlreadyClient {...props} />,
  [ERROR_PAGES.INCOMPATIBLE_PROMOTION_PAGE]: (props) => (
    <IncompatiblePromotionPage {...props} />
  ),

};

export default ERROR_TO_PRINT;
